// load namespace
let SV;
SV = window.SV || {};

SV.HoverIntent = (function () {
    // constructor
    return function (elements, userConfig) {
        // private members

        const defaultOptions = {
            exitDelay: 400,
            interval: 100,
            sensitivity: 7,
        };
        let config = {};

        let currX, currY, prevX, prevY;
        let allElems, pollTimer, exitTimer;

        // private methods

        // override default options with user config
        const extend = function (defaults, userArgs) {
            for (let i in userArgs) {
                defaults[i] = userArgs[i];
            }

            return defaults;
        };

        // update mouse position
        const mouseTrack = function (ev) {
            currX = ev.pageX;
            currY = ev.pageY;
        };

        // check if mouse movement has slowed enough to trigger active state
        const mouseCompare = function (targetElem) {
            const distX = prevX - currX,
                distY = prevY - currY;
            const distance = Math.sqrt(distX * distX + distY * distY);

            if (distance < config.sensitivity) {
                // if we re-entered an element, cancel delayed exit and clear any active elements immediately
                clearTimeout(exitTimer);
                for (let elem of allElems) {
                    if (elem.isActive) {
                        config.onExit(elem);
                        elem.isActive = false;
                    }
                }

                // trigger hover
                config.onEnter(targetElem);
                targetElem.isActive = true;
            } else {
                // update previous coordinates and try again later
                prevX = currX;
                prevY = currY;
                pollTimer = setTimeout(function () {
                    mouseCompare(targetElem);
                }, config.interval);
            }
        };

        const init = function (elements, userConfig) {
            if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
                throw "onEnter and onExit callbacks must be provided";
            }
            config = extend(defaultOptions, userConfig);
            allElems = elements;

            for (let elem of allElems) {
                // holds current element state
                elem.isActive = false;
                // keeps track of mouse position
                elem.addEventListener("mousemove", mouseTrack);

                elem.addEventListener("mouseenter", function (ev) {
                    // set initial entry position
                    prevX = ev.pageX;
                    prevY = ev.pageY;
                    // if this element is already active, cancel exit
                    if (elem.isActive) {
                        clearTimeout(exitTimer);
                        return;
                    }

                    // while mouse is over this element, check distance every 100ms
                    pollTimer = setTimeout(function () {
                        mouseCompare(elem);
                    }, config.interval);
                });
                elem.addEventListener("mouseleave", function (ev) {
                    clearTimeout(pollTimer);
                    if (!elem.isActive) return;

                    exitTimer = setTimeout(function () {
                        config.onExit(elem);
                        elem.isActive = false;
                    }, config.exitDelay);
                });
            }
        };

        init(elements, userConfig);
    };
})();

let $megaMenuToggle = $("[data-mega-menu-toggle]");
let $megaMenuToggleLink = $megaMenuToggle.find("> a");
var instance = new SV.HoverIntent($megaMenuToggle, {
    onEnter: function (targetItem) {
        // find the item, which is a <li>
        let $item = $(targetItem);
        // Add an active class for styling, etc
        if ($item.hasClass("is--mega-menu")) $item.addClass("is--open");
        // Get the nearest mega menu
        let $megaMenuContainer = $item.find("[data-mega-menu]");
        // Show the mega menu
        $megaMenuContainer.addClass("is--open");
        // Find all links and make it a different text colour
        $megaMenuToggleLink.addClass("opacity-50");
        // Find the link and make it a different text colour
        let $link = $item.find("> a");
        // Focus the current link
        $link.removeClass("opacity-50");
    },
    onExit: function (targetItem) {
        // Remove the open class
        $("[data-mega-menu-toggle]").removeClass("is--open");
        // Reset all links
        $megaMenuToggleLink.removeClass("opacity-50");
        // Hide the panels
        $("[data-mega-menu]").removeClass("is--open");
    },
    sensitivity: 7,
});
